export default __webpack_public_path__ + "static/media/net.f815178d.svg";